if (!customElements.get('ga-service-panel')) {
  customElements.define('ga-service-panel', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.onChange = () => this.showChoice(this.select.value, true);
      this.onPop = () => this.showChoice(new URL(location.href).searchParams.get('variant') || this.dataset.defaultVariant, false);
      this.select.addEventListener('change', this.onChange);
      window.addEventListener('popstate', this.onPop);
    }
    showChoice(id, updateUrl) {
      const panels = [...this.querySelectorAll('[data-service-variant]')];
      if (!panels.some(panel => panel.dataset.serviceVariant === id)) id = this.dataset.defaultVariant;
      this.select.value = id;
      panels.forEach(panel => { panel.hidden = panel.dataset.serviceVariant !== id; });
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', id);
        history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.select?.removeEventListener('change', this.onChange);
      window.removeEventListener('popstate', this.onPop);
    }
  });
}
